import axios from 'axios';
import Vuex from 'vuex';
import blog from './store/blog';
import slider from './store/slider';
import numproducts from './store/numproducts';
import products from './store/products';
import main from './store/main';
import counter from './store/counter';
import brand from './store/brand';
import section from './store/section';
import filter from './store/filter';
import catalog_action from './store/catalog_action';
import basket from './store/basket';
import detail from './store/detail';
import similarproducts from './store/similarproducts';
import order from './store/order';
import address from './store/address';
import address_detail from './store/address_detail';
import report from './store/report';
import orders from './store/orders';
import order_detail from './store/order_detail';
import notification from './store/notification';
import products_list from './store/products_list';
import page from './store/page';
import debt from './store/debt';

export default new Vuex.Store({
    state: {
        isAuth: null,
        user: {},
        uuid: '',
        device: '',
        device_uuid: '',
        errorRequest: false,
        error: false
    },
    mutations: {
        Auth(state, data) {
            state.device = data.device;
            state.device_uuid = data.uuid;
            if (data.ID) {
                state.isAuth = true;
                state.user = {
                    admin: data.ADMIN,
                    name: data.NAME,
                    last_name: data.LAST_NAME,
                    second_name: data.SECOND_NAME,
                    phone: data.PHONE,
                    email: data.EMAIL,
                    bar_name: data.UF_BAR_NAME,
                    manager_name: data.UF_MANAGER_NAME,
                    manager_phone: data.UF_MANAGER_PHONE,
                    debt: data.UF_DEBT,
                    over_debt: data.UF_OVER_DEBT,
                    day: data.PERSONAL_BIRTHDAY?parseInt(data.PERSONAL_BIRTHDAY.split('.')[0]):'',
                    month: data.PERSONAL_BIRTHDAY?parseInt(data.PERSONAL_BIRTHDAY.split('.')[1]):'',
                    year: data.PERSONAL_BIRTHDAY?parseInt(data.PERSONAL_BIRTHDAY.split('.')[2]):'',
                    birthday: data.PERSONAL_BIRTHDAY
                }
            }
            else
                state.isAuth = false;
        },
        Uuid(state, data) {
            state.uuid = data
        },
        logout(state) {
            state.isAuth = false;
            state.user = {}
        },
        setError(state, data) {
            state.errorRequest = true;
            state.error = data;
        }
    },
    actions: {
        async Auth({commit, dispatch}, data) {
            commit('Auth', data);
            try {
                if (typeof window.FirebasePlugin != 'undefined') {
                    if (!window.FirebasePlugin.hasPermission()) {
                        window.FirebasePlugin.grantPermission(function () {
                            window.FirebasePlugin.getToken(async function (device_token) {
                                axios.post('api/token/', {
                                    uuid: data.uuid,
                                    token: device_token,
                                    device: data.device
                                });
                            }, function (error) {
                                //alert('error')
                            });
                        }, function (error) {
                            //alert(error);
                        });
                    }
                    window.FirebasePlugin.getToken(async function (device_token) {
                        axios.post('api/token/', {
                            uuid: data.uuid,
                            token: device_token,
                            device: data.device
                        },{
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }});
                    }, function (error) {
                        //alert('error')
                    });
                }
            }
            catch (err) {
                let form = new FormData();
                form.append("useragent", window.navigator.userAgent)
                form.append("date", new Date());
                form.append("error", err);
                /*let response = fetch('https://mcbuy.mobileapp.alm.su/api/log/', {
                    method: 'POST',
                    body: form
                });*/
                axios.post('api/log/', form,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }});
            }
        },

        AuthRepeat({commit, dispatch}, data) {
            commit('Auth', data);
        },
        async logout({commit, dispatch, state}) {
            await axios.post('api/user/logout/', {uuid: state.device_uuid},
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            commit('logout');
        },
        async setError({commit, dispatch}, data) {
            commit('setError', data);
        }
    },
    getters: {
        isAuth: s => s.isAuth,
        device_uuid: s => s.device_uuid,
        device: s => s.device,
        user: s => s.user,
        errorRequest: s => s.errorRequest
    },
    modules: {
        blog,
        slider,
        numproducts,
        products,
        main,
        counter,
        brand,
        section,
        filter,
        catalog_action,
        basket,
        detail,
        similarproducts,
        order,
        address,
        address_detail,
        report,
        orders,
        order_detail,
        notification,
        products_list,
        page,
        debt
    }
})
